import { render, staticRenderFns } from "./administrativeDetail.vue?vue&type=template&id=4fb93a27&scoped=true&"
import script from "./administrativeDetail.vue?vue&type=script&lang=js&"
export * from "./administrativeDetail.vue?vue&type=script&lang=js&"
import style0 from "./administrativeDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./administrativeDetail.vue?vue&type=style&index=1&id=4fb93a27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb93a27",
  null
  
)

export default component.exports